import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import dayjs from "dayjs";
import { STATUS_GOOD, STATUS_CRITICAL, TEXT_PRIMARY, TEXT_SECONDARY, GRIDLINE } from "./palette";
import { formatAmount } from "./format";

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  padding: 0.6em 0;

  &:not(:first-child) {
    border-top: 1px solid ${GRIDLINE};
  }
`;

const Details = styled.div`
  min-width: 0;
`;

const Note = styled.div`
  color: ${TEXT_PRIMARY};
  white-space: pre-wrap;
  word-break: break-all;
`;

const Meta = styled.div`
  font-size: 12px;
  color: ${TEXT_SECONDARY};
  margin-top: 2px;
`;

const Amount = styled.div`
  flex-shrink: 0;
  font-weight: 600;
  color: ${(props) => props.$color};
`;

export default function SpendingRow({ spending }) {
  const isIncome = spending.category.type === "income";

  return (
    <Row>
      <Details>
        <Note>{spending.note}</Note>
        <Meta>
          {dayjs(Number(spending.date)).format("YYYY/MM/DD")} · {spending.category.name}
        </Meta>
      </Details>
      <Amount $color={isIncome ? STATUS_GOOD : STATUS_CRITICAL}>
        {isIncome && "+"}
        {formatAmount(spending.amount)}
      </Amount>
    </Row>
  );
}

SpendingRow.propTypes = {
  spending: PropTypes.shape({
    date: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    category: PropTypes.shape({ name: PropTypes.string, type: PropTypes.string }).isRequired,
  }).isRequired,
};
